import React, { FunctionComponent } from 'react'

import { Button, Logo } from '@scentregroup/ui'

import style from './index.scss'

interface LayoutProps {
  showBack: boolean
  onBackClicked: () => void
  children: JSX.Element | JSX.Element[]
}

const Layout: FunctionComponent<LayoutProps> = ({
  showBack,
  onBackClicked,
  children,
}) => (
  <div className={style.Layout}>
    <div className={style.Content}>{children}</div>
    <footer className={style.Footer}>
      <div>
        {showBack && <Button onClick={onBackClicked}>&larr; Home</Button>}
      </div>
      <Logo className={style.Logo} />
    </footer>
  </div>
)

export default Layout
